"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _FormControlContext = require("../FormControl/FormControlContext");
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _tss = require("../styles/tss");
const _excluded = ["children", "classes", "className", "component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsFormHelperText',
  uniqId: '3O9KlM'
})((theme, _params, classes) => {
  const {
    typography
  } = theme.busbud;
  return {
    /* Styles applied to the root element. */
    root: _objectSpread(_objectSpread({}, typography.font.component.text.sm), {}, {
      fontWeight: theme.busbud.fontWeight.bold,
      margin: 0,
      [`&.${classes.disabled}`]: {
        color: theme.palette.text.disabled
      },
      [`&.${classes.error}`]: {
        color: theme.palette.error.main
      }
    }),
    /* Styles applied to the root element if `margin="dense"`. */
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
});
/**
 * **❗️ DEPRECATED**
 *
 * A FormHelperText provides feedback about the form input field.
 * It appears below the input field.
 *
 * @deprecated
 */
const FormHelperText = /*#__PURE__*/_react.default.forwardRef(function FormHelperText(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      component: Component = 'p'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const dsFormControl = (0, _FormControlContext.useFormControl)();
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['disabled', 'error', 'filled', 'focused', 'required']
  });
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.filled]: fcs.filled,
      [classes.required]: fcs.required,
      [classes.error]: fcs.error,
      [classes.focused]: fcs.focused,
      [classes.disabled]: fcs.disabled
    }, className),
    ref: ref
  }, other), children);
});
var _default = exports.default = FormHelperText;